<template lang="html">
    <div style="text-align: right; font-size: 11px;">
        <span v-if="loading == false">
            Son Güncelleme: {{lastUpdate}}
        </span>
        <span v-if="loading">
            Yeni veriler yükleniyor...
        </span>
    </div>
</template>

<script>
import moment from 'moment';
moment.locale('tr');

export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
            required: false
        },
        timeout: {
            type: Number,
            default: 120,
            required: false
        }
    },
    data: function () {
        return {
            lastUpdate: undefined,
            timeoutId: undefined
        }
    },
    watch: {
        loading: function () {
            if (this.loading == false) {
                var $this = this;
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    $this.$emit('refreshData');
                }, this.timeout * 1000);
                this.lastUpdate = moment().format('DD.MM.YYYY HH:mm:ss');
            } else {
                clearTimeout(this.timeoutId);
            }
        }
    },
    destroyed: function () {
        clearTimeout(this.timeoutId);
    }
}
</script>


// WEBPACK FOOTER //
// auto_update.vue?9ea6e71e